"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineVersionsByStatus = void 0;
const getOrderLineVersionsByStatus = (versions, status) => {
    if (!versions || versions.length === 0)
        return null;
    return versions.filter((version) => {
        return version.status === status;
    });
};
exports.getOrderLineVersionsByStatus = getOrderLineVersionsByStatus;
